import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "c-bg--gray c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = {
  ref: "content",
  class: "p-the-page-j05"
}
const _hoisted_4 = { class: "c-common-inner" }
const _hoisted_5 = { class: "p-the-page-j05__inner" }
const _hoisted_6 = { class: "p-thread-header" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "p-thread-header__name",
  "data-translate-skip": ""
}
const _hoisted_9 = { class: "p-the-page-j05__body" }
const _hoisted_10 = {
  ref: "chatContainer",
  class: "p-the-page-j05__chat-container"
}
const _hoisted_11 = {
  key: 0,
  ref: "textareaElement",
  class: "p-the-page-j05__form"
}
const _hoisted_12 = {
  key: 1,
  class: "p-the-page-j05__message__note"
}
const _hoisted_13 = {
  key: 2,
  class: "p-the-page-j05__message__note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_TheJ05ChatScreen = _resolveComponent("TheJ05ChatScreen")!
  const _component_TheJ05ChatForms = _resolveComponent("TheJ05ChatForms")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: "p-thread-header__back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goMessageList && _ctx.goMessageList(...args)))
              }, "❮"),
              _createVNode(_component_IconUserImage, { size: 32 }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.partnerUserImage,
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.partnerUserName), 1),
              (_ctx.sendApproval == 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "p-thread-header__thanks-btn",
                    style: _normalizeStyle({ background: _ctx.colorCode }),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goGiveThanksPoint && _ctx.goGiveThanksPoint(...args)))
                  }, " この人に贈る ", 4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_TheJ05ChatScreen, {
                  "chat-log": _ctx.internalChatLog,
                  "unread-row-no": _ctx.unreadRowNo,
                  "partner-user-image": _ctx.partnerUserImage
                }, null, 8, ["chat-log", "unread-row-no", "partner-user-image"])
              ], 512),
              (_ctx.thread_enabled && _ctx.sendApproval == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_TheJ05ChatForms, { onDoSend: _ctx.doSend }, null, 8, ["onDoSend"])
                  ], 512))
                : _createCommentVNode("", true),
              (!_ctx.thread_enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.thread_enabled && _ctx.sendApproval == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_SmallText, null, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" この人へ新規メッセージ送信はできません。 ", -1)
                      ])),
                      _: 1,
                      __: [2]
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512)
    ]),
    _createVNode(_component_TheFooter)
  ]))
}